export class StringUtils{

   
    private constructor(){}
    static curpRegexString():string{
        let regex = "^[a-zA-Z]{4}[\\d]{6}[a-zA-Z]{6}[0-9a-zA-Z]{2}";
        return regex;
    }

    static rfcRegexString():string{
        let regex = "[a-zA-Z]{4}[\\d]{6}([a-zA-Z0-9]{3})";
        return regex;
    }
    
}